import { render, staticRenderFns } from "./ProvisionAndLimiteOverview.vue?vue&type=template&id=4375c992"
import script from "./ProvisionAndLimiteOverview.vue?vue&type=script&lang=ts"
export * from "./ProvisionAndLimiteOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/operator/locales/i18n-provision-and-limite-overview.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Foperator%2Fchildrens%2FProvisionAndLimiteOverview.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports